<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-header [appName]="appName" navStyle="top">
  <fab-basic-header-action *ngIf="userService.hasAnyAuthorities(['hr','manager'])" [matTooltip]="'Settings'" iconName="settings"
                           (iconClick)="openModal()"></fab-basic-header-action>
  <fab-app-info [appName]="appName"
                [appVersion]="appVersion"
                [appVersionCodename]="appVersionCodename"
                [apiMap]="apiMap"
                [buildNumber]="buildNumber"
                [environmentName]="environmentName"></fab-app-info>
  <fab-user-info [user]="user"></fab-user-info>
</fab-header>


<fab-topnav [userAuthorities]="userAuthorities">
  <fab-breadcrumbs homeRoute="/" mode="content"></fab-breadcrumbs>
  <router-outlet></router-outlet>
</fab-topnav>

<ng-template #countryDialog>
  <p>Please select your region?</p>
  <mat-form-field>
    <mat-label>Country</mat-label>
    <mat-select #selectedCountryName [(value)]="selectedCountry">
      <mat-option *ngFor="let country of countryValues" [value]="country.value">
        {{country.displayValue}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <br/>
  <div>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="save(selectedCountry || '')">Save
      </button>
      <button mat-raised-button (click)="close()">Cancel
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
